// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_4mKMF"};